<template>
  <el-card header="新建文章">
      <el-form :model="Articles"
               :rules="rules"
               ref="ruleForm"
               label-position="right"
               label-width="160px"
      >
      <el-form-item label="主要分类" prop="cate_id">
        <el-select v-model="Articles.cate_id" placeholder="请选择" @change="changeCate">
          <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="次要分类" prop="cateList">
        <el-checkbox-group v-model="Articles.cateList">
          <el-checkbox v-for="item in cateList"
                       :key="item.id"
                       :label="item.id"
                       :value="item.id" v-bind:disabled="Articles.cate_id==item.id">{{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="标题" prop="title" class="before">
        <el-input v-model="Articles.title"></el-input>
      </el-form-item>
      <!--<el-form-item label="封面图" prop="img">-->
        <!--<img-upload :return-url="true" v-model="Articles.img"></img-upload>-->
      <!--</el-form-item>-->
      <el-form-item label="来源" prop="from">
        <el-input v-model="Articles.from"></el-input>
      </el-form-item>
      <!--<el-form-item label="是否首页顶部推荐" prop="is_home_rec">-->
        <!--<el-radio v-model="Articles.is_home_rec" label="1">是</el-radio>-->
        <!--<el-radio v-model="Articles.is_home_rec" label="0">否</el-radio>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="排序" prop="sort">-->
        <!--<el-input-number v-model="Articles.sort"></el-input-number>-->
      <!--</el-form-item>-->
      <el-form-item label="内容" prop="content">
        <textarea id="content"></textarea>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="articlesCreate(Articles)">创建</el-button>
        <el-button type="success" @click="backPage">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import back from '@/mixin/back'
  import Upload from "element-ui/packages/upload/src/upload";
  import ImgUpload from "../img/ImgUpload";
  import config from "@/lib/http/config"

  export default {
    name: "ArticlesCreate",
    mixins: [back],
    components: {ImgUpload, Upload},
    created() {
      this.$store.dispatch('articles/getCateList');
    },
    computed: {
      ...mapState({
        cateList: state => state.articles.cateList,
        // Articles: state => state.articles.newArticles,
        rules: state => state.articles.rules,
        loading: state => state.articles.loading,
      }),
    },
    methods: {
      setContent(content) {
        CKEDITOR.instances.content.setData(content);
      },
      articlesCreate(Articles) {
        let vthis = this;
        this.$refs['ruleForm'].validate(validate => {
          if (!validate) {
            return;
          }
          this.content = CKEDITOR.instances.content.getData();
          Articles.content = CKEDITOR.instances.content.getData();
          this.$store.dispatch('articles/create', Articles).then((res) => {
            vthis.$confirm('是否关闭此页面').then(_ => {
              vthis.$router.go(-1);
            }).catch(_ => {
            });
          })
        });
      },
      //下拉选择切换
      changeCate(selVal){
          //当前选中的值
          var cate_id = selVal;
          this.Articles.cateList=[];
          //循环复选框并将该值复选框置位选中且置灰；
          this.Articles.cateList.push(cate_id);
      }
    },
    data() {
      return {
        Articles: {
          sort: '1',
          is_home_rec: '0',
          cateList: [],
        },
      };
    },
    mounted (){
      CKEDITOR.replace('content', {
        filebrowserImageUploadUrl: config.baseURL + '/api/ck/upload',
        language: 'zh-cn',
        height: 400,
      });
      // this.setContent("<p>asdfasdf</p>");
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/articles/ArticlesCreate.vue